export const usd = (n) => `$${Number(n) % 1 ? Number(n).toFixed(2) : Number(n)}`;
